<template>
  <div class="login">
    <div class="mask"></div>
    <img
      v-show="bgflag"
      src="../assets/images/insects/question_bg.png"
    >
    <div class='mackContend'>
      <div
        class='mackClose'
        @click="closeLogin"
      ><img src="../assets/images/insects/btn_close.png"></div>
      <div class='quesContend'>
        <div>
          <div class="hunzilogin"><img src="../assets/images/insects/hunzilogin.png"></div>
          <div class="hunzinput">
            <input
              v-model="phone"
              placeholder="请输入手机号"
            />
          </div>
          <div class="hunzCodeinput code">
            <input
              v-model="imageCode"
              placeholder="请输入图形验证码"
            /><img :src="'data:image/png;base64,'+ico" class="rightulliimg" align="absmiddle" @click="getImageCode()" >
            </div>
          <div class="hunzinput code">
            <input
              v-model="code"
              placeholder="请输入验证码"
            />
            <div class="msgCode">| <span
                @click="getMsgCode"
                v-if="!getCodeFlag"
              >获取验证码</span> <span
                class="gray"
                v-if="getCodeFlag"
              ><i>{{second}}</i>s后重新获取</span></div>
          </div>
        </div>
        <div
          class="submit"
          @click="confirm"
        ><img src="../assets/images/insects/btn_confirm.png"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from "vant";

export default {
  name: "login",
  data() {
    return {
      bgflag: false,
      phone: "",
      code: "",
      timer2: null,
      second: 60,
      imageCode:"",
      ico:"",
      uuid:"",
      getCodeFlag: false,
    };
  },
 async created() {
    this.getImageCode();
    const that = this;
    that.timer2 = setInterval(function() {
      console.log(document.readyState);
      if (document.readyState === "complete") {
        that.$emit("loginReady", true);
        window.clearInterval(that.timer2);
      }
    }, 1000);

  },
  methods: {
    async getImageCode(){
      let response = await axios.get(
        "/app/api/captchaImage?with=160&height=88&fontSize=40"
      );
      //console.info(response.data.data.uuid)
       if (response.status == 200) {
         this.ico=response.data.data.img
          this.uuid=response.data.data.uuid
       }
    },
    start: function() {
      var vm = this;
      if (vm.getCodeFlag) return;
      vm.getCodeFlag = true;
      var time = setInterval(() => {
        var second = vm.second;
        second--;
        vm.second = second;

        if (second == 0) {
          clearInterval(time);
          vm.second = 60;
          vm.getCodeFlag = false;
        }
      }, 1000);
    },
    async confirm() {
      let reg = /^1[0-9]{10}$/;

      if (this.phone == "") {
        console.log(this.phone);
        Toast.fail("请输入手机号");
        return false;
      }
      if (!reg.test(this.phone)) {
        Toast.fail("请输入正确的手机号");
        return false;
      }
      if (this.code == "") {
        console.log(this.code);
        Toast.fail("请输入验证码");
        return false;
      }
 
      axios.defaults.headers.post["Content-Type"] = "application/json";
      let response = await axios.post("/app/api/fan/SMSLogin", {
        mobile: this.phone,
        SMSCode: this.code,
        channelId: 99,
      });
      console.log("登录用户信息");
      console.log(response);
      if (response.status == 200) {
        // console.log(response.data.data)
        if (response.data.status == "0000") {
          localStorage.setItem("userInfo", JSON.stringify(response.data.data));
          localStorage.setItem("token", response.headers.authorization);
          this.$emit("successLogin", true);
          this.closeLogin();
        } else {
          Toast.fail(response.data.msg);
          return false;
        }
      }
    },
    async getMsgCode() {
      let reg = /^1[0-9]{10}$/;
      if (this.phone == "") {
        console.log(this.phone);
        Toast.fail("请输入手机号");
        return false;
      }
      if (!reg.test(this.phone)) {
        Toast.fail("请输入正确的手机号");
        return false;
      }
     if (this.imageCode == "") {
        Toast.fail("请输入图形验证码");
        return false;
      }
  
      let response = await axios.get(
        "/app/api/fan/sendLogInSMS?mobile=" + this.phone+"&uuid="+this.uuid+"&code="+this.imageCode
      );
      if (response.status == 200) {
        console.log(response.data.msg);
        if (response.data.msg != "成功") {
          Toast.fail(response.data.msg);
          return false;
        }
      }
      this.start();
    },
    closeLogin() {
      this.$emit("closeLogin");
    },
  },
};
</script>

<style scoped>
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #000000;
  opacity: 0.7;
  z-index: 6;
}
.mackContend {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 664px;
  height: 643px;
  margin: -321px 0 0 -332px;
  z-index: 7;
  background: url("../assets/images/insects/question_bg.png");
  background-size: contain;
}
.mackContend .mackClose {
  width: 64px;
  height: 64px;
  position: absolute;
  right: -20px;
  top: -20px;
}
.mackContend .mackClose img {
  width: 100%;
  height: 100%;
}
.mackContend .quesContend {
  margin: 40px 80px;
}
.mackContend .quesContend h3 {
  font-size: 36px;
  color: #a06c46;
  text-align: center;
}
.mackContend .quesContend .submit {
  margin-top: 60px;
  text-align: center;
}
.mackContend .quesContend .submit img {
  width: 311px;
  height: 97px;
}
.hunzilogin {
  width: 441px;
  height: 59px;
  margin: 70px auto;
}
.hunzilogin img {
  width: 100%;
  height: 100%;
}

.hunzinput input {
  background: transparent;
  width: 100%;
  height: 88px;
  padding: 20px;
  border: 2px solid #a06c46;
  font-size: 28px;
}

.hunzCodeinput input {
  background: transparent;
  width: 60%;
  height: 88px;
  padding: 20px;
  border: 2px solid #a06c46;
  font-size: 28px;
}
.hunzCodeinput.code {
  margin-top: 40px;
  position: relative;
}
.hunzinput.code {
  margin-top: 40px;
  position: relative;
}
.msgCode {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #a06c46;
  font-size: 28px;
}
.msgCode span {
  display: inline-block;
  width: 200px;
}
.msgCode span i {
  display: inline-block;
  font-style: normal;
  width: 40px;
}
.msgCode span.gray {
  color: #999999;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #a06c46;
  font-size: 28px;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #a06c46;
  font-size: 28px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #a06c46;
  font-size: 28px;
}
.rightulliimg {  
  width: 40%;
  height: 88px;
}  
</style>
